import { useEffect } from 'react';

// Google Analytics 4 Measurement ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window === 'undefined' || GA_MEASUREMENT_ID === 'G-XXXXXXXXXX') {
    return;
  }

  // Check if script already exists
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
    return;
  }

  // Load Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true, // GDPR compliance
    cookie_flags: 'SameSite=None;Secure'
  });
};

// Track page views
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('form_submission', 'engagement', formName);
};

// Track CTA clicks
export const trackCTAClick = (ctaName) => {
  trackEvent('cta_click', 'engagement', ctaName);
};

// Track calculator usage
export const trackCalculatorUsage = (industry, savings) => {
  trackEvent('calculator_usage', 'engagement', industry, savings);
};

// Google Analytics Component
function GoogleAnalytics() {
  useEffect(() => {
    // Check cookie consent before initializing
    const consent = localStorage.getItem('ubotika_cookie_consent');
    if (consent) {
      try {
        const consentData = JSON.parse(consent);
        if (consentData.preferences?.analytics?.enabled) {
          initGA();
        }
      } catch (e) {
        // Invalid consent data, don't initialize
      }
    }

    // Listen for consent changes
    const handleStorageChange = (e) => {
      if (e.key === 'ubotika_cookie_consent') {
        try {
          const consentData = JSON.parse(e.newValue);
          if (consentData.preferences?.analytics?.enabled) {
            initGA();
          }
        } catch (error) {
          // Invalid consent data
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return null; // This component doesn't render anything
}

export default GoogleAnalytics;
